import { render, staticRenderFns } from "./ScoreSettingImport.vue?vue&type=template&id=124bfb1e"
import script from "@/controllers/custom/score_setting/score-setting-import.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/score_setting/score-setting-import.js?vue&type=script&lang=js&external"
import style0 from "./ScoreSettingImport.vue?vue&type=style&index=0&id=124bfb1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports